import styled from 'styled-components';

export const StyledProgress = styled.progress`
  width: 100%;
`;
